import { render, staticRenderFns } from "./TilesWrapper.vue?vue&type=template&id=a8321df4&scoped=true"
import script from "./TilesWrapper.vue?vue&type=script&lang=js"
export * from "./TilesWrapper.vue?vue&type=script&lang=js"
import style0 from "./TilesWrapper.vue?vue&type=style&index=0&id=a8321df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8321df4",
  null
  
)

export default component.exports